<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .program_list -->
            <b-col lg="12">
              <b-form-group
                id="input-group-29"
                :label="$t('edu_programs.name')"
                label-for="input-29"
              >
                <b-form-input
                  id="input-29"
                  v-model="newItem.name"
                  type="text"
                  :placeholder="$t('edu_programs.name')"
                />
              </b-form-group>
              <!-- .explanation -->
            </b-col>
            <b-col lg="12">
              <b-form-group
                id="input-group-30"
                :label="$t('edu_programs.explanation')"
                label-for="input-30"
              >
                <ckeditor
                  :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                  v-model="newItem.explanation"
                  :placeholder="$t('edu_programs.explanation')"
                />
              </b-form-group>
              <!-- .icon_path -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-31"
                :label="$t('edu_programs.icon')"
                label-for="input-31"
              >
                <b-form-file
                  id="wildcard"
                  v-model="newItem.icon"
                  accept="image/*"
                  :placeholder="$t('edu_programs.icon')"
                />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('program_lists.program_list')"
                label-for="input-1"
              >
                <b-form-select
                  id="input-1"
                  v-model="newItem.program_list_id"
                  :options="program_listOptions"
                  text-field="name"
                  value-field="id"
                  :placeholder="$t('program_lists.program_list')"
                ></b-form-select>
              </b-form-group>
              <!-- .edu_season -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('edu_programs.h_study_start_date')"
                label-for="input-5"
              >
                <date-picker
                  :placeholder="$t('edu_programs.h_study_start_date')"
                  v-model="newItem.h_study_start_date"
                  :locale="'ar-eg'"
                  calendar="hijri"
                  @change="toDateG($event, 'g_study_start_date')"
                />
              </b-form-group>
              <!-- .g_study_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-6"
                :label="$t('edu_programs.g_study_start_date')"
                label-for="input-6"
              >
                <b-form-input
                  id="input-6"
                  v-model="newItem.g_study_start_date"
                  type="text"
                  readonly
                  :placeholder="$t('edu_programs.g_study_start_date')"
                />
              </b-form-group>
              <!-- .h_study_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-7"
                :label="$t('edu_programs.h_study_end_date')"
                label-for="input-7"
              >
                <date-picker
                  :placeholder="$t('edu_programs.h_study_end_date')"
                  v-model="newItem.h_study_end_date"
                  :locale="'ar-eg'"
                  calendar="hijri"
                  @change="toDateG($event, 'g_study_end_date')"
                />
              </b-form-group>
              <!-- .g_study_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-8"
                :label="$t('edu_programs.g_study_end_date')"
                label-for="input-8"
              >
                <b-form-input
                  id="input-8"
                  v-model="newItem.g_study_end_date"
                  type="text"
                  readonly
                  :placeholder="$t('edu_programs.g_study_end_date')"
                />
              </b-form-group>
              <!-- .h_register_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-9"
                :label="$t('edu_programs.h_register_start_date')"
                label-for="input-9"
              >
                <date-picker
                  :placeholder="$t('edu_programs.h_register_start_date')"
                  v-model="newItem.h_register_start_date"
                  :locale="'ar-eg'"
                  calendar="hijri"
                  @change="toDateG($event, 'g_register_start_date')"
                />
              </b-form-group>
              <!-- .g_register_start_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-10"
                :label="$t('edu_programs.g_register_start_date')"
                label-for="input-10"
              >
                <b-form-input
                  id="input-10"
                  v-model="newItem.g_register_start_date"
                  type="text"
                  readonly
                  :placeholder="$t('edu_programs.g_register_start_date')"
                />
              </b-form-group>
              <!-- .h_register_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-11"
                :label="$t('edu_programs.h_register_end_date')"
                label-for="input-11"
              >
                <date-picker
                  :placeholder="$t('edu_programs.h_register_end_date')"
                  v-model="newItem.h_register_end_date"
                  :locale="'ar-ar'"
                  calendar="hijri"
                  ref="h_register_end_date"
                  :min="newItem.g_register_start_date"
                  @change="toDateG($event, 'g_register_end_date')"
                />
              </b-form-group>
              <!-- .g_register_end_date -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-12"
                :label="$t('edu_programs.g_register_end_date')"
                label-for="input-12"
              >
                <b-form-input
                  id="input-12"
                  v-model="newItem.g_register_end_date"
                  type="text"
                  readonly
                  :placeholder="$t('edu_programs.g_register_end_date')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="4">
              <b-form-group
                id="input-group-14"
                :label="$t('edu_programs.subscription_type')"
                label-for="input-14"
              >
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="newItem.subscription_type"
                    name="some-radios"
                    value="free"
                    checked="true"
                  >
                    {{ $t("edu_programs.free") }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="newItem.subscription_type"
                    name="some-radios"
                    value="paid"
                  >
                    {{ $t("edu_programs.paid") }}
                  </b-form-radio>
                </div>
              </b-form-group>
              <!-- .subscription_fees -->
            </b-col>
              <b-col lg="4">
              <b-form-group
                id="input-group-25"
                :label="$t('edu_programs.scheduled_lectures')"
                label-for="input-25"
              >
                <b-form-checkbox
                  class="custom-control-primary"
                  name="check-button"
                  v-model="newItem.flixable"
                  switch
                  value="1"
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
              <!-- .meta_data -->
            </b-col>

          </b-row>
          <b-row v-if="newItem.subscription_type == 'paid'">
            <b-col lg="4">
              <b-form-group
                id="input-group-15"
                :label="$t('edu_programs.subscription_fees')"
                label-for="input-15"
              >
                <b-form-input
                  id="input-15"
                  v-model="newItem.subscription_fees"
                  type="number"
                  :placeholder="$t('edu_programs.subscription_fees')"
                />
              </b-form-group>
              <!-- .icon -->
            </b-col>
            <b-col lg="4">
              <b-form-group
                id="input-group-23"
                label="امكانية التقسيط"
                label-for="input-23"
              >
                <b-form-checkbox
                  class="custom-control-primary"
                  name="check-button"
                  v-model="newItem.can_installment"
                  switch
                  value="1"
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
              <!-- .installment_period -->
            </b-col>
            <b-col lg="4" v-if="newItem.can_installment == 1">
              <b-form-group
                id="input-group-24"
                label="فترة التقسيط"
                label-for="input-24"
              >
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="newItem.installment_period"
                    name="installment_period"
                    value="3"
                    checked
                  >
                    3
                  </b-form-radio>
                  <b-form-radio
                    v-model="newItem.installment_period"
                    name="installment_period"
                    value="6"
                  >
                    6
                  </b-form-radio>
                  <b-form-radio
                    v-model="newItem.installment_period"
                    name="installment_period"
                    value="12"
                  >
                    12
                  </b-form-radio>
                </div>
              </b-form-group>
              <!-- .flixable -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/EduProgramsController";
import config from "../../../../config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "@validations";
import Program_listsController from "@/Controllers/Program_listsController";
import Edu_seasonsController from "@/Controllers/Edu_seasonsController";
import VueDatetimeJs from "vue-datetime-js";
let controller = new Controller();
export default {
  name: "EduProgramsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    "date-picker": VueDatetimeJs,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
      program_list: [],
      edu_season: [],
      program_listOptions: [],
      edu_seasonOptions: [],
      programType: [],
    };
  },
  async created() {
    this.programType = controller.programType();
    this.program_listOptions = await new Program_listsController().GetAll({filter : "is_course|1"});
    this.edu_seasonOptions = await new Edu_seasonsController().GetAll();
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.is_course = 1;
      let ret = await controller.From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    toDateG(evt, gdDate) {
      console.log(this.$refs.h_register_end_date);
      this.newItem[gdDate] = evt.toISOString().split("T")[0];
      // this.$refs.h_register_end_date.min=evt.toISOString().split("T")[0];
    },
    changeEduSeason(value) {
      let eduSeason = this.edu_seasonOptions.find((a) => a.id == value);
      this.$set(this.newItem, "h_study_start_date", eduSeason.h_start_date);
      this.$set(this.newItem, "g_study_start_date", eduSeason.g_start_date);

      this.$set(this.newItem, "h_study_end_date", eduSeason.h_end_date);
      this.$set(this.newItem, "g_study_end_date", eduSeason.g_end_date);

      console.log(this.newItem);
    },
  },
};
</script>
